<template>
	<div class="row align-items-end">
		<div class="col-12 col-lg-6">
			<card  class="mr-3"><div class="preview d-flex justify-content-center"><img :src="preview_img_src"></div></card>
		</div>
		<div class="col-12 col-lg-6">
			<card>
				<h4 v-if="this.$GVO.my_profile.adm != 1 && this.$GVO.my_profile.AdsMaster != 1" class="text-center"> <i class="tim-icons icon-alert-circle-exc text-danger mb-2 mr-2"></i>У Вас не достаточно прав доступа на редактирование модуля</h4>
				<div v-if="this.$GVO.my_profile.adm == 1 || this.$GVO.my_profile.AdsMaster == 1" >
					<div class="row" >
						<label class="col-form-label col-md-12 pb-1"><span>Загрузка надписи</span></label>
						<div class="form-group col-md-12">
							<ReFileUpload 
								v-model="wm_img_src"
								:type="'file'"
								:formId="'watermarkUpload'+'_'+Math.random()"
								:bShowTrash="true"
								acceptMime="image/png"
								strFilrPath="/DATA/watermark/"
								:uploadApi="uploadApi"
								:delApi="delApi"
								v-on:change="OnUploadFile"
								:bShowDraggable="false"
							/>
						</div>
					</div>

					<div class="row">
						<label class="col-form-label col-md-12"><span>Прозрачность</span></label>
						<div class="col-md-12">
							<div class="form-group">
								<div class="mb-0">
									<input
										type="number"
										placeholder="Прозрачность"
										class="form-control"
										v-model.lazy="iOpacity"
										onwheel="return false;"
										:min = "0"
										:max = "100"
									/>
								</div>
							</div>
						</div>
					</div>

					<div class="row">
						<label class="col-form-label col-md-12"><span>Позиция</span></label>
						<!--
						<div class="col-md-12 d-flex" style="align-items: center;">
							<el-select
								class="w-100 select-primary "
								size="large"
								placeholder="Позиция"
								v-model="sPosition"
								@change="onPosChange"
							>
								<el-option
									v-for="(el_opt, el_index) in masPositions"
									class="select-primary"
									:value="el_opt.value"
									:label="el_opt.label"
									:key="el_index"
								>
								</el-option>
							</el-select>
							<base-button type="danger" class="no-border my-0" simple icon @click="sPosition = 'center';"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
						</div>
						-->
						<ReSelectClearable v-model="sPosition" @change="onPosChange" :options="masPositions" placeholder="Позиция" :clearValue="'center'"/>
					</div>

					<div class="row">
						<label class="col-form-label col-md-12"><span>Поворот</span></label>
						<el-button class="no-border my-0">
							<button class="ml-3 btn btn-icon btn-simple btn-primary" @click="OnRotate(iRotateAngle, 'left')">
								<i class="mirror tim-icons icon-refresh-01"></i>
							</button>
						</el-button>
						<el-button class="no-border my-0">
							<button class="ml-3 btn btn-icon btn-simple btn-primary" @click="OnRotate(iRotateAngle, 'right')">
								<i class="tim-icons icon-refresh-01"></i>
							</button>
						</el-button>
					</div>

				
					<div class="row mt-3">
						<el-button class="no-border my-0">
							<button class="ml-3 btn btn-icon btn-simple btn-success" @click="Save()">
								<i class="tim-icons icon-book-bookmark"></i>
							</button>
						</el-button>
						<!--
						<el-button class="no-border my-0">
							<button class="ml-3 btn btn-icon btn-simple btn-danger" @click="Del()">
								<i class="tim-icons icon-book-bookmark"></i>
							</button>
						</el-button>
						-->
					</div>
				</div>
			</card>
		</div>
	</div>
</template>
<script>

/* Сломалась реактивность на объекте или массиве: 
	Этот чудесный кослыль родился потому что VUE не может нормально следить за массивами и теряется реактивность
	https://v2.vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats

Для объекта:
	this.$set(this.objChosenTP,this.ApiData[i].siteId, {'choise':'','cost':0, 'phone':{"contact_id":"","contact_type":"1","contact_value":"","contact_view":"","contact_group":"phone"}});
Для Массива:
	Vue.set(this.masCheckListParams,obj_index, [{val_id:obj_index, elements: masElements}]);
*/
// import swal from 'sweetalert2';
import { Select, Option, Tooltip, Button } from 'element-ui';
import ReFileUpload from 'src/our_components/ReFileUpload.vue';
import ReSelectClearable from 'src/our_components/ReSelectClearable.vue';

export default {
	name: 'watermark-page',
	components: {
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
		ReFileUpload,
		ReSelectClearable
	},
	data() {
		return {
			ApiData: [],
			objGetParams:{},
			preview_img_src: '/DATA/watermark/demo_img.jpg',
			demo_img_src: '/DATA/watermark/demo_img.jpg',
			wm_img_src: [],
			iRotateAngle: 1,
			masPositions: [{value: 'center', label: 'По центру',},{value: 'topleft', label: 'Сверху слева',},{value: 'topright', label: 'Сверху справа',},{value: 'bottomright', label: 'Снизу справа',},{value: 'bottomleft', label: 'Снизу слева',}],
			sPosition: 'center',
			iCurAngle: 0,
			iOpacity: 70,
			uploadApi: {"apiMethod":"UniUpload","apiParam":{"obj":"FileUpload","flt":{"type":"watermark_files"}}},
			delApi: {"apiMethod":"DEL_WM_IMG","apiParam":{"obj":"watermark","flt":{"id":-1}}},
			wm_id: -1,
			temRotateAngle: 0,
		};
	},
	methods: {
		getApiData(){
			this.$GVO.ApiCall('watermark.GET',{flt:{'list':'true'}})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						//console.log('getApiData',objApi.data);
						this.delApi.apiParam.flt.id = objApi.data[0].id;
						this.wm_id = objApi.data[0].id;
						this.wm_img_src = [];
						this.wm_img_src.push(objApi.data[0].wm_file);
						this.sPosition = objApi.data[0].position;
						this.iCurAngle = objApi.data[0].angle;
						this.iOpacity = objApi.data[0].opacity;
						// this.temRotateAngle = objApi.data[0].angle;
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		Del(){
			//this.getApiData();
		},
		Save(iRotate){
			
			// iRotate = this.temRotateAngle;
			
			this.$GVO.ApiCall('watermark.INSUPD',{flt:{'id':this.wm_id},iData:{
				'wm_file':this.wm_img_src[0],
				'position':this.sPosition,
				'opacity':this.iOpacity,
				'angle':this.iCurAngle,
				'rotate':iRotate,
			}}).then((objApi) => {
				if(objApi.success === true){
					//this.getApiData();
					this.ApplyWatermark();
					// console.log('iRotate',iRotate);
				} else {this.$GVO.showAlert('Редактирование watermark',objApi.msg);}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		onPosChange(opt){
			// console.log(opt);
			this.sPosition = opt;
			this.Save();
		},
		OnUploadFile(objUpload){
			//console.log(objUpload);
			if(typeof objUpload == 'string' && objUpload == '')this.wm_img_src=[];
			if(objUpload == null) return false;
			if(typeof objUpload.selfObj != 'undefined'){
				if(!this.$GVO.isEmpty(objUpload.selfObj.uploadApi)){
					this.bUploading=true;
					this.$GVO.UploadFile(objUpload.formId, objUpload.selfObj.uploadApi.apiMethod, objUpload.selfObj.uploadApi.apiParam)
						.then(objApi => {
							//console.log(objApi);
							if(objApi.success){
								this.wm_img_src=[];
								this.wm_img_src.push(objApi.data.fullpath);
								//вот тут надо обновить или добавить файл вотермарки в таблицу настроек вотермарки
								this.Save();
							}else{
								//console.log(objApi.msg);
								this.$GVO.showAlert('Загрузка файлов',objApi.msg);
							}
							//this.ApplyWatermark();
							this.bUploading=false;
						})
						.catch(errorObjApi => 	{  console.error(errorObjApi); this.bUploading=false;});
				}
			}
		},
		OnRotate(angle, side){
			if(this.sPosition == 'center'){
				if(side == 'left'){
					angle = (-1)*angle;
				} //else {}
				// console.log(angle);
				// this.temRotateAngle = angle;
				this.Save(angle);
				
			}
		},
		ApplyWatermark(){
			this.$GVO.ApiCall('watermark.watermark_apply',{flt:{'file':this.demo_img_src}})
			.then((objApi) => {
				if(objApi.success === true){
					let date = new Date();
					this.preview_img_src = objApi.data.file_dst+'?ts=' + date.getTime();
					this.getApiData();
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		}
	},		
	mounted() {
		this.getApiData();
	}
};
</script>
<style>
	div.preview>img{height: 320px;}
	i.mirror{transform: scale(-1, 1) !important; top: 20% !important;left: 20% !important;}
</style>
